var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:forward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33464 11.334L6.28464 10.4007L3.21797 7.33398L6.28464 4.26732L5.33464 3.33398L1.33464 7.33398L5.33464 11.334ZM14.668 12.6673V10.0007C14.668 9.07843 14.3429 8.29243 13.6926 7.64265C13.0424 6.99287 12.2564 6.66776 11.3346 6.66732H7.21797L9.61797 4.26732L8.66797 3.33398L4.66797 7.33398L8.66797 11.334L9.61797 10.4007L7.21797 8.00065H11.3346C11.8902 8.00065 12.3624 8.1951 12.7513 8.58398C13.1402 8.97287 13.3346 9.4451 13.3346 10.0007V12.6673H14.668Z",
    fill: "#435869"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrive);
export default __webpack_public_path__ + "static/media/icon-arrive.80573ebe4d67b8e8b538b9f2205b094a.svg";
export { ForwardRef as ReactComponent };